import { useState } from "react";
import "./Reconciliation.css";

export default function ReconciliationLogin({ onLogin }) {
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const res = await fetch("/api/reconciliation/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Ошибка входа");
      onLogin(data.token, data.user);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="recon-login-page">
      <div className="recon-login-box">
        <div className="recon-login-logo">
          <span className="recon-login-icon">⬡</span>
          <div>
            <div className="recon-login-title">THOTH AI</div>
            <div className="recon-login-sub">Сверка с БК</div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="recon-login-form">
          <div className="recon-login-field">
            <label>Email</label>
            <input
              type="email" value={email} autoFocus
              onChange={e => setEmail(e.target.value)}
              placeholder="you@nomera.ru"
              required
            />
          </div>
          <div className="recon-login-field">
            <label>Пароль</label>
            <input
              type="password" value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>
          {error && <div className="recon-login-error">{error}</div>}
          <button type="submit" className="recon-login-btn" disabled={loading}>
            {loading ? "Вход..." : "Войти"}
          </button>
        </form>
      </div>
    </div>
  );
}
